import { useEffect, useRef, useState } from "react";

import EventEmitter from "eventemitter3";
import React from "react";
import StoreProps from "../../../types/Store";
import Store from "../../Store";
import Translation from "../../Translation";

const SCROLL_POSITION_KEY = "scrollPosition";

const StoreSelector = () => {
    const [currentStore, setCurrentStore] = useState<
        StoreProps | undefined | null
    >(Store.getCurrentStore());
    const [contentShown, setContentShown] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(Store.loading);
    const allStores = Store.getAllStores() as StoreProps[];
    const selectorRef = useRef<HTMLDivElement>(null);
    const EEE = new EventEmitter();

    EEE.on("STORE_CHANGED", (id: number) => {
        onStoreChanged(id);
    });

    EEE.on("STORE_LOADING", (status) => {
        onStoreLoading(status);
    });

    const onStoreLoading = (
        status: boolean | ((prevState: boolean) => boolean),
    ) => {
        if (status !== loading) setLoading(status);
    };

    const onStoreChanged = (id: number) => {
        if (currentStore && currentStore.id !== id) {
            Store.setStore(id);
            setCurrentStore(Store.getCurrentStore());
        }
    };

    const onStoreChangeClick = (id: number) => {
        EEE.emit("STORE_CHANGED", id); // TODO: Remove?
        Store.setStore(id);
        sessionStorage.setItem(SCROLL_POSITION_KEY, window.scrollY.toString());
        window.location.reload();
    };

    const handleClick = (event: MouseEvent) => {
        if (
            selectorRef.current &&
            !selectorRef.current.contains(event.target as Node)
        ) {
            // If the click is outside the menu, hide the menu/content
            setContentShown(false);
        }
    };

    const isFocusInsideSelector = (): boolean => {
        const focusedElement = document.activeElement;
        if (selectorRef.current && focusedElement) {
            return selectorRef.current.contains(focusedElement);
        }
        return false;
    };

    const handleKeydown = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            setContentShown(false);
        }
        if (event.key === "Tab") {
            setTimeout(() => {
                if (!isFocusInsideSelector()) {
                    setContentShown(false);
                }
            }, 0);
        }
    };

    useEffect(() => {
        const scrollPosition = sessionStorage.getItem(SCROLL_POSITION_KEY);
        if (scrollPosition) {
            window.scrollTo(0, parseInt(scrollPosition));
            sessionStorage.removeItem(SCROLL_POSITION_KEY);
        }

        document.addEventListener("click", (e) => handleClick(e));
        document.addEventListener("keydown", (e) => handleKeydown(e));
        return () => {
            document.removeEventListener("click", (e) => handleClick(e));
            document.removeEventListener("keydown", (e) => handleKeydown(e));
        };
    }, []);

    const buttonAltText = contentShown
        ? "Stäng menyn"
        : `Byt butik. Vald butik ${currentStore?.title}. ${currentStore?.opening_hours_small}.`;

    return (
        <div className="store-selector" ref={selectorRef}>
            {currentStore && (
                <>
                    <button
                        aria-controls="storeSelectorContent"
                        aria-expanded={contentShown}
                        aria-label={buttonAltText}
                        className={`store-selector__button button ${contentShown ? "expanded" : ""}`}
                        onClick={() => setContentShown(!contentShown)}
                    >
                        {Translation.getText("Store", "ChangeStore")}
                        <i className="fa-solid fa-angle-down"></i>
                    </button>

                    {contentShown && (
                        <div
                            className="store-selector__content"
                            id="storeSelectorContent"
                        >
                            <ul className="store-selector__switch-store-nav">
                                {allStores.map((store: StoreProps) => {
                                    const hasOffers =
                                        store.offers_weekly?.offers?.length > 0;
                                    return (
                                        <li key={store.id.toString()}>
                                            <a
                                                className={`${store.id === currentStore.id ? "active" : ""}`}
                                                href={
                                                    hasOffers ? "" : store.link
                                                }
                                                onClick={() => {
                                                    if (hasOffers)
                                                        onStoreChangeClick(
                                                            store.id,
                                                        );
                                                }}
                                                data-click-type="nav"
                                                data-click-location="dropdown"
                                            >
                                                {store.title}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default StoreSelector;
